const eur = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" });

export const formatEUR = (value) => eur.format(Number(value) || 0);

export const formatShortEUR = (value) => `${String(Number(value) || 0).replace(".", ",")} €`;

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (typeof d?.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return "Si è verificato un problema. Riprova tra poco.";
}

export const formatDate = (iso) => {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};
